qw-carousel.swiper-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.qw-image__loaded img {
  width: 100%;
}

